import { render, staticRenderFns } from "./SignView.vue?vue&type=template&id=8c620042&scoped=true&"
import script from "./SignView.vue?vue&type=script&lang=js&"
export * from "./SignView.vue?vue&type=script&lang=js&"
import style0 from "./SignView.vue?vue&type=style&index=0&id=8c620042&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c620042",
  null
  
)

export default component.exports